// extracted by mini-css-extract-plugin
export default {"sideNav":"DashboardSideNav_sideNav__atKNZ","navItem":"DashboardSideNav_navItem__RRU8H","active":"DashboardSideNav_active__xwCBe"};